
export const cookieConsentTranslations = {
  en: {
    cookieConsent: {
      message: 'We use cookies to enhance your experience on our site. Some are essential for the site to work properly.',
      learnMore: 'Cookie Policy',
      acceptAll: 'Accept All',
      rejectAll: 'Reject All',
      manage: 'Manage Cookies',
      close: 'Close',
      required: 'Required',
      categories: {
        essential: {
          title: 'Essential Cookies',
          description: 'These cookies are necessary for the website to function and cannot be switched off in our systems.'
        },
        preferences: {
          title: 'Preference Cookies',
          description: 'These cookies allow the website to remember choices you make and provide enhanced, personalized features.'
        },
        analytics: {
          title: 'Analytics Cookies',
          description: 'These cookies help us understand how visitors interact with our website, helping us improve our services.'
        },
        marketing: {
          title: 'Marketing Cookies',
          description: 'These cookies are used to track visitors across websites to enable us to display relevant advertisements.'
        }
      },
      preferences: {
        title: 'Cookie Preferences',
        description: 'Manage your cookie preferences. You can enable or disable different types of cookies below. Essential cookies cannot be disabled.',
        save: 'Save Preferences',
        cancel: 'Cancel'
      }
    }
  },
  es: {
    cookieConsent: {
      message: 'Utilizamos cookies para mejorar su experiencia en nuestro sitio. Algunas son esenciales para que el sitio funcione correctamente.',
      learnMore: 'Política de Cookies',
      acceptAll: 'Aceptar Todo',
      rejectAll: 'Rechazar Todo',
      manage: 'Administrar Cookies',
      close: 'Cerrar',
      required: 'Requerido',
      categories: {
        essential: {
          title: 'Cookies Esenciales',
          description: 'Estas cookies son necesarias para que el sitio web funcione y no se pueden desactivar en nuestros sistemas.'
        },
        preferences: {
          title: 'Cookies de Preferencias',
          description: 'Estas cookies permiten que el sitio web recuerde las opciones que realiza y proporcione funciones mejoradas y personalizadas.'
        },
        analytics: {
          title: 'Cookies Analíticas',
          description: 'Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web, ayudándonos a mejorar nuestros servicios.'
        },
        marketing: {
          title: 'Cookies de Marketing',
          description: 'Estas cookies se utilizan para rastrear a los visitantes en los sitios web y permitirnos mostrar anuncios relevantes.'
        }
      },
      preferences: {
        title: 'Preferencias de Cookies',
        description: 'Administre sus preferencias de cookies. Puede habilitar o deshabilitar diferentes tipos de cookies a continuación. Las cookies esenciales no se pueden deshabilitar.',
        save: 'Guardar Preferencias',
        cancel: 'Cancelar'
      }
    }
  },
  de: {
    cookieConsent: {
      message: 'Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Einige sind für die Funktionalität der Website unerlässlich.',
      learnMore: 'Cookie-Richtlinie',
      acceptAll: 'Alle Akzeptieren',
      rejectAll: 'Alle Ablehnen',
      manage: 'Cookies Verwalten',
      close: 'Schließen',
      required: 'Erforderlich',
      categories: {
        essential: {
          title: 'Essentielle Cookies',
          description: 'Diese Cookies sind für das Funktionieren der Website notwendig und können in unseren Systemen nicht deaktiviert werden.'
        },
        preferences: {
          title: 'Präferenz-Cookies',
          description: 'Diese Cookies ermöglichen es der Website, sich an Ihre Auswahl zu erinnern und verbesserte, personalisierte Funktionen anzubieten.'
        },
        analytics: {
          title: 'Analyse-Cookies',
          description: 'Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, was uns hilft, unsere Dienstleistungen zu verbessern.'
        },
        marketing: {
          title: 'Marketing-Cookies',
          description: 'Diese Cookies werden verwendet, um Besucher auf Websites zu verfolgen, damit wir relevante Werbung anzeigen können.'
        }
      },
      preferences: {
        title: 'Cookie-Präferenzen',
        description: 'Verwalten Sie Ihre Cookie-Präferenzen. Sie können verschiedene Arten von Cookies unten aktivieren oder deaktivieren. Essentielle Cookies können nicht deaktiviert werden.',
        save: 'Einstellungen Speichern',
        cancel: 'Abbrechen'
      }
    }
  },
  fr: {
    cookieConsent: {
      message: "Nous utilisons des cookies pour améliorer votre expérience sur notre site. Certains sont essentiels au bon fonctionnement du site.",
      learnMore: "Politique de Cookies",
      acceptAll: "Tout Accepter",
      rejectAll: "Tout Refuser",
      manage: "Gérer les Cookies",
      close: "Fermer",
      required: "Requis",
      categories: {
        essential: {
          title: "Cookies Essentiels",
          description: "Ces cookies sont nécessaires au fonctionnement du site web et ne peuvent pas être désactivés dans nos systèmes."
        },
        preferences: {
          title: "Cookies de Préférences",
          description: "Ces cookies permettent au site web de mémoriser vos choix et de proposer des fonctionnalités améliorées et personnalisées."
        },
        analytics: {
          title: "Cookies d'Analyse",
          description: "Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site web, ce qui nous aide à améliorer nos services."
        },
        marketing: {
          title: "Cookies de Marketing",
          description: "Ces cookies sont utilisés pour suivre les visiteurs sur les sites web afin de permettre l'affichage de publicités pertinentes."
        }
      },
      preferences: {
        title: "Préférences de Cookies",
        description: "Gérez vos préférences de cookies. Vous pouvez activer ou désactiver différents types de cookies ci-dessous. Les cookies essentiels ne peuvent pas être désactivés.",
        save: "Enregistrer les Préférences",
        cancel: "Annuler"
      }
    }
  },
  hi: {
    cookieConsent: {
      message: "हम अपनी साइट पर आपके अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करते हैं। साइट को ठीक से काम करने के लिए कुछ आवश्यक हैं।",
      learnMore: "कुकी नीति",
      acceptAll: "सभी स्वीकार करें",
      rejectAll: "सभी अस्वीकार करें",
      manage: "कुकीज़ प्रबंधित करें",
      close: "बंद करें",
      required: "आवश्यक",
      categories: {
        essential: {
          title: "आवश्यक कुकीज़",
          description: "ये कुकीज़ वेबसाइट के कार्य करने के लिए आवश्यक हैं और हमारे सिस्टम में बंद नहीं की जा सकती हैं।",
        },
        preferences: {
          title: "वरीयता कुकीज़",
          description: "ये कुकीज़ वेबसाइट को आपके द्वारा चुने गए विकल्पों को याद रखने और उन्नत, व्यक्तिगत सुविधाएँ प्रदान करने की अनुमति देती हैं।",
        },
        analytics: {
          title: "विश्लेषिकी कुकीज़",
          description: "ये कुकीज़ हमें यह समझने में मदद करती हैं कि आगंतुक हमारी वेबसाइट के साथ कैसे बातचीत करते हैं, जिससे हमें अपनी सेवाओं को बेहतर बनाने में मदद मिलती है।",
        },
        marketing: {
          title: "मार्केटिंग कुकीज़",
          description: "इन कुकीज़ का उपयोग वेबसाइटों पर आगंतुकों को ट्रैक करने के लिए किया जाता है ताकि हम प्रासंगिक विज्ञापन प्रदर्शित कर सकें।",
        },
      },
      preferences: {
        title: "कुकी वरीयताएँ",
        description: "अपनी कुकी वरीयताएँ प्रबंधित करें। आप नीचे विभिन्न प्रकार की कुकीज़ को सक्षम या अक्षम कर सकते हैं। आवश्यक कुकीज़ को अक्षम नहीं किया जा सकता है।",
        save: "वरीयताएँ सहेजें",
        cancel: "रद्द करें",
      },
    }
  }
};
